import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/novelcraft/banner.webp";

function Banner() {
  return (
    <section
      className="banner_novelcraft"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={10} lg={8} xl={6} xxl={6} className="mx-auto">
            <h1 style={{ color: "#fff" }}>
              NovelCraft – iOS and Android Mobile App Development
            </h1>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
